<template>
  <div class="ln-user-account">
    <span class="form-title">当前账号:</span>
    <h2 class="number">
      {{ user.account || '请先登录' }}
      <van-button v-if="user.is_bind != 1" type="info" size="small" @click="bindPhone">绑定手机</van-button>
    </h2>
    <div v-if="user.is_guest">
      <span class="form-title">账号密码</span>
      <h2 class="number">
        {{ showUpass || '******' }}
        <!-- <van-icon class="eye-icon" :name="`${isShowPass ? 'closed-eye' : 'eye-o'}`" @click="toggleShowPass" /> -->
      </h2>
    </div>
    <Form ref="form">
      <div class="bottom">
        <Row class="login-row">
          <Button class="login-btn" block type="info" native-type="button" @click="toggleAccount('Login')">
            切换账号
          </Button>
        </Row>
      </div>
    </Form>
    <van-icon
      v-if="user.force_cert_status != 0"
      style="position:absolute;right:0;top:0;right:10px;top:10px;"
      name="cross"
      @click="closeWindow"
    />
  </div>
</template>

<script>
import { Form, Button, Row, Dialog } from 'vant';
import { mapState } from 'vuex';
import mixServer from '../server/mixServer';
import server from '@/server';
import { sendMsg } from '@/server';
import { notificationPostmessager } from '../features/notificationPostmessager';

export default {
  name: 'ln-user-account',
  components: { Form, Row, Button },
  data() {
    return {
      isShowPass: false
    };
  },
  computed: {
    ...mapState(['user']),
    showUpass() {
      const passwd = this.user.passwd;
      return this.isShowPass ? passwd : passwd.replace(/./g, '*');
    }
  },
  created() {},
  mounted() {
    // console.log(this.user)
  },
  methods: {
    toggleShowPass() {
      this.isShowPass = !this.isShowPass;
    },
    closeWindow() {
      this.$store.commit('CLOSE');
    },
    bindPhone() {
      if (!this.user.account) {
        Dialog({ message: '请先登录' });
        return;
      }
      this.changeComponent('BindPhone');
    },
    changeComponent(components) {
      if (components == 'Login') {
        clearInterval(server.timer);
        if (mixServer.game_link.indexOf('huanyuantech.com') > -1) {
          console.log({ account: mixServer.mixAccount, uid: mixServer.ouid, token: mixServer.mixToken });
          this.$store.commit('SET_CHANGECLICK', true);
          sendMsg('LOGOUT_SUCCESS', { account: mixServer.mixAccount, uid: mixServer.ouid, token: mixServer.mixToken });
        }
      }
      this.$store.commit('SHOW', components);
      const needRefreshGame = ['https://sdk.sh9130.com', 'https://h5.uu89.com'];
      const isRefresh = needRefreshGame.some(v => mixServer.game_link.indexOf(v) > -1);
      if (isRefresh && components == 'Login') {
        const gameFrame = document.querySelector('#gameFrame');
        gameFrame.src = `${mixServer.game_link}?v=${new Date().getTime()}`;
      }

      // if (mixServer.game_link.indexOf('https://sdk.sh9130.com') > -1 && components == 'Login') {
      //   const gameFrame = document.querySelector('#gameFrame');
      //   gameFrame.src = `${mixServer.game_link}?v=${new Date().getTime()}`;
      // }
      // if (mixServer.game_link.indexOf('https://cls-wc02.huanyuantech.com') > -1 && components == 'Login') {
      //   const gameFrame = document.querySelector('#gameFrame');
      //   gameFrame.src = `${mixServer.game_link}&v=${new Date().getTime()}`;
      // }
    },
    toggleAccount() {
      this.changeComponent('Login');
      // 切换账号时：【通知中心】断开长连接
      notificationPostmessager.emit({
        action: 'NOTIFICATION_DISCONNECT',
        data: {}
      });
    }
  }
};
</script>
<style lang="scss">
@import '@/assets/css/var.scss';
.ln-user-account {
  .number {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: $theme-color;
    margin: 5px 15px;
    font-size: 20px;
    .eye-icon {
      color: #969799;
    }
  }
}
</style>
